var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"answerBox",staticClass:"answerBox",style:({width: _vm.colWidth+'mm', left: _vm.left+'mm', top: _vm.top+'mm'})},_vm._l(((_vm.end-_vm.start)),function(n){return _c('chooseOne',{ref:"chooseOne",refInFor:true,attrs:{"type":_vm.type,"seq":(n+_vm.start-1),"limit":_vm.limit}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }